// app.component.ts
import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { MenubarComponent } from './components/menubar/menubar.component';
import { DarkModeService } from './services/dark-mode.service';
import { filter, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bnpp-indx-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [HeaderComponent, FooterComponent, MenubarComponent, RouterOutlet, CommonModule],
  standalone: true,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'bnpp-indx';
  private readonly darkModeService = inject(DarkModeService);
  public hideHeaderFooter = signal<boolean>(false);
  private subscription?: Subscription;
  private readonly router = inject(Router);

  public ngOnInit() {
    this.darkModeService.initDarkMode();

    this.subscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        const url = this.router.url;
        return url.startsWith('/nr/');
      })
    ).subscribe((isRulebookRoute: boolean) => {
      this.hideHeaderFooter.set(isRulebookRoute);
    });
  }


  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
